import { useEffect, useRef, useState } from 'react';

export function TargetStat({number, label}){
  // "+5" o "11" se animan como contador; textos como "INDECOPI" se muestran tal cual
  const match = /^(\+?)(\d+)$/.exec(number);
  const prefix = match ? match[1] : "";
  const target = match ? Number(match[2]) : null;

  const [value, setValue] = useState(target === null ? null : 0);
  const ref = useRef(null);

  useEffect(() => {
    if (target === null) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      setValue(target);
      return;
    }

    let frame;
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      observer.disconnect();

      const start = performance.now();
      const duration = 1400;
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        setValue(Math.round(target * eased));
        if (progress < 1) frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
    }, { threshold: 0.6 });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
  }, [target]);

  return(
    <div className="target-stat" ref={ref}>
      <p className="stat-number">{target === null ? number : `${prefix}${value}`}</p>
      <p className="stat-label">{label}</p>
    </div>
  );
}
